import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { EmpresaComboFilterService } from './empresa-combo-filter.service';

@Component({
  selector: 'app-empresa-combo',
  templateUrl: './empresa-combo.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmpresaComboComponent),
      multi: true,
    },
  ],
})
export class EmpresaComboComponent implements ControlValueAccessor {
  @Input() label = 'Empresa';
  @Input() placeholder = 'Buscar por código Domínio ou nome...';
  @Input() help = 'Use o código da empresa no Domínio (codi_emp), não o ID interno do sistema.';
  @Input() required = true;
  @Input() disabled = false;
  @Input() name = 'empresaCombo';

  value: number | null = null;
  private onChangeFn: (v: number | null) => void = () => {};
  onTouchedFn: () => void = () => {};

  constructor(public filterService: EmpresaComboFilterService) {}

  writeValue(value: number | null): void {
    this.value = value ?? null;
  }

  registerOnChange(fn: (v: number | null) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange(selected: number | null): void {
    this.value = selected ?? null;
    this.onChangeFn(this.value);
    this.onTouchedFn();
  }
}
